const DRAFT_REMINDER_YANDEX_GOALS = {
  show: 'draftReminder__show', // Показ
  notNow: 'draftReminder__notNow', // Нажатие на "Не сейчас"
  goToReview: 'draftReminder__goToReview', // Нажатие на "К отзыву"
}

export default DRAFT_REMINDER_YANDEX_GOALS
